var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"navigation-item text-md"},[_c('v-link',{attrs:{"anchor":_vm.anchor,"handler":_vm.onClick}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }